import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb"
import { Button } from "@/components/ui/button"
import { Separator } from "@/components/ui/separator"
import AppLayout from "@/layouts/AppLayout"
import { Head, useForm } from "@inertiajs/react"
import { IconArrowLeft, IconUpload } from "@tabler/icons-react"
import { useState } from "react"

export default function ExchangeRateImport() {
  const { data, setData, post, processing } = useForm<{ csv_file: File | null }>({
    csv_file: null,
  })
  const [fileName, setFileName] = useState("")

  function handleFileChange(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0] || null
    setData("csv_file", file)
    setFileName(file?.name || "")
  }

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    post("/exchange_rates/process_import", { forceFormData: true })
  }

  return (
    <>
      <Head title="Import Exchange Rates - Operations Center" />
      <div className="flex flex-1 flex-col gap-6 p-4 lg:p-6">
        <div className="space-y-4">
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href="/">Home</BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbLink href="/exchange_rates">Exchange Rates</BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>Import</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>

          <div className="flex items-center gap-3">
            <Button variant="ghost" size="icon" className="h-8 w-8" asChild>
              <a href="/exchange_rates">
                <IconArrowLeft className="h-4 w-4" />
              </a>
            </Button>
            <h1 className="text-lg font-semibold tracking-tight">Import Exchange Rates</h1>
          </div>
        </div>

        <div className="max-w-lg">
          <form onSubmit={handleSubmit}>
            <div className="rounded-xl border bg-card">
              <div className="p-6 space-y-5">
                <div
                  className="flex h-32 w-full cursor-pointer flex-col items-center justify-center rounded-lg border border-dashed transition-colors hover:bg-muted/50"
                  onClick={() => document.getElementById("csv-input")?.click()}
                >
                  <IconUpload className="text-muted-foreground mb-2 h-6 w-6" />
                  <p className="text-sm">
                    {fileName ? (
                      <span className="font-medium">{fileName}</span>
                    ) : (
                      <>
                        <span className="text-muted-foreground">Drop CSV or </span>
                        <span className="text-foreground font-medium">browse</span>
                      </>
                    )}
                  </p>
                </div>
                <input id="csv-input" type="file" accept=".csv" className="hidden" onChange={handleFileChange} />

                <Separator />

                <div className="bg-muted/50 rounded-lg p-4 text-sm">
                  <p className="font-medium mb-2">Expected CSV format:</p>
                  <code className="text-xs text-muted-foreground block">
                    date,currency_from,currency_to,buy_rate,sell_rate
                    <br />
                    2024-01-15,usd,uyu,38.50,40.50
                  </code>
                </div>
              </div>

              <Separator />
              <div className="flex justify-end gap-2 p-4">
                <Button variant="ghost" asChild>
                  <a href="/exchange_rates">Cancel</a>
                </Button>
                <Button type="submit" disabled={processing || !data.csv_file}>
                  {processing ? "Importing..." : "Import"}
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

ExchangeRateImport.layout = (page: React.ReactNode) => <AppLayout>{page}</AppLayout>
